// extracted by mini-css-extract-plugin
module.exports = {"auth":"login_auth__3vOXC","error":"login_error__2CZCh"};